function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8.875,
  y: 6.43766,
  width: 11.8125,
  height: 12.625,
  rx: 1,
  fill: "#3D6AC2",
  stroke: "#3D6AC2",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 6.48518C3 5.49952 3.71812 4.66081 4.69203 4.50903L12.067 3.35968C13.2797 3.17069 14.375 4.10848 14.375 5.33583V20.1642C14.375 21.3915 13.2797 22.3293 12.067 22.1403L4.69203 20.991C3.71812 20.8392 3 20.0005 3 19.0148V6.48518Z",
  fill: "#3D6AC2",
  stroke: "white",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09723 10.1025C9.1622 10.1025 9.22254 10.114 9.27823 10.1369C9.33624 10.1598 9.38729 10.1918 9.43138 10.233C9.47779 10.272 9.51724 10.32 9.54972 10.3773C9.58221 10.4322 9.60542 10.4918 9.61934 10.5559L10.218 13.2964H10.3364C10.4338 12.8499 10.5336 12.3943 10.6357 11.9296C10.7378 11.4625 10.8399 11.0046 10.942 10.5559C10.9629 10.4689 10.9942 10.3899 11.036 10.3189C11.0731 10.2594 11.1242 10.2056 11.1891 10.1575C11.2564 10.1071 11.3435 10.0819 11.4502 10.0819C11.5314 10.0819 11.6022 10.0968 11.6625 10.1266C11.7252 10.1541 11.7762 10.1907 11.8157 10.2365C11.8574 10.28 11.8876 10.3281 11.9062 10.3807C11.9271 10.4334 11.9375 10.4849 11.9375 10.5353C11.9375 10.5627 11.9363 10.5891 11.934 10.6142C11.9317 10.6394 11.9282 10.6612 11.9236 10.6795C11.9189 10.7024 11.9143 10.723 11.9097 10.7413L10.9559 14.4778C10.9211 14.5556 10.8747 14.6243 10.8167 14.6838C10.768 14.7365 10.7042 14.7846 10.6253 14.8281C10.5487 14.8693 10.4524 14.8899 10.3364 14.8899H10.218C10.102 14.8899 10.0069 14.8693 9.9326 14.8281C9.85835 14.7846 9.79918 14.7365 9.75509 14.6838C9.70404 14.6243 9.66575 14.5556 9.64022 14.4778L9.15292 12.4653H9.03458C8.96032 12.7904 8.88027 13.1258 8.79441 13.4715C8.71087 13.8173 8.63081 14.1527 8.55424 14.4778C8.52407 14.5556 8.48346 14.6243 8.43241 14.6838C8.386 14.7365 8.32567 14.7846 8.25142 14.8281C8.17948 14.8693 8.0855 14.8899 7.96948 14.8899H7.85113C7.73511 14.8899 7.63649 14.8693 7.55527 14.8281C7.47637 14.7846 7.4114 14.7365 7.36035 14.6838C7.30002 14.6243 7.25245 14.5556 7.21764 14.4778L6.27785 10.7413C6.2732 10.723 6.26856 10.7024 6.26392 10.6795C6.25928 10.6612 6.2558 10.6394 6.25348 10.6142C6.25116 10.5891 6.25 10.5627 6.25 10.5353C6.25 10.4849 6.25928 10.4334 6.27785 10.3807C6.29873 10.3281 6.3289 10.28 6.36834 10.2365C6.41011 10.1907 6.46116 10.1541 6.5215 10.1266C6.58415 10.0968 6.65608 10.0819 6.7373 10.0819C6.84404 10.0819 6.9299 10.1071 6.99487 10.1575C7.06217 10.2056 7.11438 10.2594 7.15151 10.3189C7.19328 10.3899 7.2246 10.4689 7.24549 10.5559L7.85113 13.2964H7.96948C8.01357 13.0858 8.06114 12.8648 8.11219 12.6336C8.16324 12.4001 8.21429 12.1654 8.26534 11.9296C8.31871 11.6915 8.37092 11.4568 8.42197 11.2255C8.47534 10.992 8.52639 10.7688 8.57512 10.5559C8.60761 10.4254 8.67026 10.3178 8.76308 10.233C8.8559 10.146 8.96728 10.1025 9.09723 10.1025Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 8.68749H20.0625",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 12.7499H20.0625",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 16.8126H20.0625",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgWordHover = function SvgWordHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wordHover.cc002cb8.svg";
export { ForwardRef as ReactComponent };